import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { TabelaComissionamentoModel } from "../model/tabela-comissionamento.model";

@Injectable()
export class TabelaComissionamentoService {
    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

   /**
     * Tabela de Comissionamento por id
     * @param id ID da Tabela de Comissionamento
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "credito/tabelas-comissionamento/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

   /**
     * Lista de Tabelas de Comissionamento
     * @param params Filtros da Tabela de Comissionamento
     */
    getAll(params: Record<string, unknown>): Observable<ApiPaginationResponseDataNonNullable<TabelaComissionamentoModel>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp !== null && paramHttp !== "") {
            env = "?" + paramHttp;
        }

        return this._http.get<ApiPaginationResponseDataNonNullable<TabelaComissionamentoModel>>(
            this.utilitesService.urlPrefix + "credito/tabelas-comissionamento" + env,
            {
                headers: this.authService.getAuthHeaders(),
            }
        );
    }

    /**
     * Busca de Tabela de Comissionamento
     * @param params Filtros da Busca
     */
    search(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "credito/tabelas-comissionamento/search" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Delete de Tabela de Comissionamento
     * @param id ID da Tabela de Comissionamento
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "credito/tabelas-comissionamento/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

   /**
     * Cadastra Tabela de Comissionamento
     * @param params Json Tabela de Comissionamento
     */
    create(params: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + "credito/tabelas-comissionamento", JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }

   /**
     * Atualiza Tabela de Comissionamento
     * @param id ID da Tabela de Comissionamento
     * @param params Json Tabela de Comissionamento
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(this.utilitesService.urlPrefix + "credito/tabelas-comissionamento/" + id, JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }
}
